import "./style.css"
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import MpBrand from "../../modules/mp-brand";
import {Button, Input} from "@mui/material";
import {useForm} from "react-hook-form";
import {useEffect, useState} from "react";
import {getAllChanels, getMP, setUpdateMP} from "../../API/api";
import MpTable from "../../modules/mp-table";
import {selectMonth} from "../../store/select-month";

const EditMP = () => {
    const [clips, setClips] = useState([]);
    const { userName } = useSelector((store) => store.userName)
    const [dayName, setDayName] = useState('ПН')
    const [rekIndex, setRekIndex] = useState(0)

    const navigate = useNavigate()

    //useForm
    const {
        register,
        handleSubmit,
        formState: {errors},
        setValue,
        watch,
        reset,
    } = useForm();

    const {id} = useParams();
    const dispatch = useDispatch();
    const {activeMonth} = useSelector((store) => store.month)
    const {activeChanel} = useSelector((store) => store.chanel)

    const monthName = (date) => (new Date(Date.parse(date)).toLocaleString('ru', {
        month: 'long', year: 'numeric'
    }))

    const parseRussianMonth = (str) => {
        if (!str) return null;

        // Приводим к нижнему регистру и убираем лишние символы вроде "г."
        const cleanStr = str.toLowerCase().replace(/[^а-я0-year0-9\s]/g, '').trim();

        const months = {
            'январь': 0, 'февраль': 1, 'март': 2, 'апрель': 3, 'май': 4, 'июнь': 5,
            'июль': 6, 'август': 7, 'сентябрь': 8, 'октябрь': 9, 'ноябрь': 10, 'декабрь': 11
        };

        // Разбиваем строку по пробелам (ожидаем [ "октябрь", "2026" ])
        const parts = cleanStr.split(/\s+/);
        const monthName = parts[0];
        const year = parseInt(parts[1], 10);

        if (months[monthName] !== undefined && !isNaN(year)) {
            // Создаем дату на 1-е число этого месяца
            return new Date(year, months[monthName], 1);
        }

        return null;
    };

    const [dayPerMonth, setDayPerMonth] = useState([])

    const [chanels, setChanels] = useState([])
    const getChanels = async () => {
        const data = await getAllChanels();
        setChanels(data)
    }
    useEffect(() => {
        getChanels();
    },[]);

    useEffect(() => {
        // 1. Проверяем, что activeMonth вообще существует в Redux
        if (!activeMonth) return;

        // 2. Проверяем, что строка даты корректна
        const parsedDate = Date.parse(activeMonth);
        if (isNaN(parsedDate)) return;

        // 3. Считаем количество дней в месяце
        const dateObj = new Date(parsedDate);
        const lastDayMonth = new Date(
            dateObj.getFullYear(),
            dateObj.getMonth() + 1,
            0
        ).getDate();

        // 4. Наполняем массив за ОДИН раз (без промежуточных перерендеров)
        const days = [];
        for (let i = 1; i <= lastDayMonth; i++) {
            days.push(i);
        }

        setDayPerMonth(days);
    }, [activeMonth]);

    //Убераем пробелы из ячеек???
    const rekSpaceDelete = (arr) => {
        for (let i = 0; i < arr.length; i++) {
            // Если элемент массива - объект
            if (typeof arr[i] === 'object' && arr[i] !== null) {
                // Проход по свойствам объекта
                for (let key in arr[i]) {
                    // Если свойство является строкой
                    if (typeof arr[i][key] === 'string') {
                        // Удаление пробелов из значения
                        arr[i][key] = arr[i][key].replace(/\s+/g, '');
                    }
                }
            }
        }
        return arr
    }


    const onSubmit = async (data) => {
        if (errors?.name) {
            console.log(errors?.name?.message);
        }
        try {
            data.user = userName
            data.clips = clips
            let rek = data.reklama
            data.reklama = rekSpaceDelete(rek)
            await setUpdateMP(localStorage.getItem("access_token"), id, data);
            navigate("/mp")
        } catch (error) {
            console.log(data)
            console.dir(error);
            throw new Error("Что-то не так с пост запросом");
        }
    }

    // Get Data
    const [dataMp, setDataMp] = useState(null)
    const getDataMp = async () => {
        const data = await getMP(localStorage.getItem("access_token"), id);
        setDataMp(data)
    }
    useEffect(() => {
        getDataMp()
    },[id]);

    useEffect(() => {
        if (dataMp && Object.keys(dataMp).length > 0) {
            setClips(dataMp?.clips);
            reset(dataMp);
        }
        // Добавляем reset в зависимости, так как react-hook-form гарантирует его стабильность
    }, [dataMp, reset]);

    useEffect(() => {
        if (dataMp) {
            setClips(dataMp?.clips);
            reset(dataMp);

            // Если в бэкенд-данных есть поле с месяцем (например, dataMp.month)
            if (dataMp.month) {
                const parsedDate = parseRussianMonth(dataMp.month);

                if (parsedDate) {
                    // Записываем дату в стор.
                    // В зависимости от того, что ждет ваш редюсер, передайте:
                    // parsedDate (объект даты) или parsedDate.toISOString() (строку)
                    dispatch(selectMonth(parsedDate.toISOString()));
                }
            }
        }
    }, [dataMp, reset, dispatch]);

    // //Get Data Block
    const [rekBlockList, setRekBlockList] = useState([])

    const blockList = () => {
        const arr = []
        rekBlockList?.map((el) => {
            const data = Object.values(el)
            if (data.length > 0) {
                arr.push(Number(data[0].length))
            }
        })

        const timeLimit = chanels[activeChanel]?.timeBlock?.[dayName]?.[rekIndex]
            ? Object.values(chanels[activeChanel]?.timeBlock?.[dayName]?.[rekIndex])[0]
            : 0
        let result1 = arr.length > 0 ? arr?.reduce((a, b) => a + b) : ""
        // let result = 180 - result1
        return timeLimit - result1

    }

    // Покраска блока
    const bgc = (time) => {
        if (time > 61) {
            return ""
        }
        if (46 <= time && time <= 60) {
            return "deepskyblue"
        }
        if (31 <= time && time <= 45) {
            return "green"
        }
        if (21 <= time && time <= 30) {
            return "yellow"
        }
        if (11 <= time && time <= 20) {
            return "orange"
        }
        if (1 <= time && time <= 10) {
            return "red"
        }
        if ( time <= 0) {
            return "black"
        }
    }

    return (
        <div className="editMP container">
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mp-head">
                <div className="mp-head-left">
                    {/*{id}*/}
                    {/*{monthName(activeMonth)}*/}
                    <div className="mp-head_text">
                        <div className="mp-head_text_left">Телеканал:</div>
                        <div className="mp-head_text_right">{chanels[activeChanel]?.chanel}</div>
                    </div>
                    <div className="mp-head_text">
                        <div className="mp-head_text_left">Пользователь:</div>
                        <div className="mp-head_text_right">{dataMp?.user}</div>
                    </div>
                    <div className="mp-head_text">
                        <div className="mp-head_text_left">Брэнд:</div>
                        <div className="mp-head_text_right">
                            <Input
                            className="mp-head_input"
                            placeholder="Название"
                            {...register("name",{
                                required: true
                            })}
                            />
                        </div>
                    </div>
                    <div className="mp-head_text">
                        <div className="mp-head_text_left">Status:</div>
                        <div className="mp-head_text_right">{dataMp?.status ? "Активный" : "Не в работе"}</div>
                    </div>
                    <div className="mp-head_text">
                        <div className="mp-head_text_left">Позиция:</div>
                        <div className="mp-head_text_right">
                            <Input
                                className="mp-head_input"
                                placeholder="Позиция"
                                {...register("position")}
                            />
                        </div>
                    </div>
                    <MpBrand
                        activeChanel={dataMp?.chanel}
                        activeMonth={dataMp?.month}
                        clips={clips}
                        setClips={setClips}

                    />
                </div>
                <div className={`mp-head-right ${bgc(Number(blockList()))}`}>
                    <span>Ролики в блоке</span>
                    {rekBlockList?.map((el, i) => {
                        const data = Object.values(el)
                        if (data.length > 0) {
                            return (<p key={i}>{data[0].name} : {data[0].length}c</p>)
                        }
                    })}
                    <span>Осталось: {blockList()} сек</span>
                </div>
            </div>

                <MpTable
                    chanels={chanels}
                    dayPerMonth={dayPerMonth}
                    register={register}
                    setValue={setValue}
                    setRekBlockList={setRekBlockList}
                    clips={clips}
                    id={id}
                    watch={watch}
                    setDayName={setDayName}
                    setRekIndex={setRekIndex}
                />
            <Button type={"submit"} variant="contained">Сохранить</Button>
                {/*<Button variant="contained" onClick={() => inWork()}>Work</Button>*/}
                <Button variant="outlined" onClick={() => navigate(-1)}>Отмена</Button>
            </form>
        </div>
    )
}

export default EditMP